module.exports = __webpack_public_path__ + "img/banner-30.a9c9f826.jpg";